<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="业主姓名" prop="ownerName">
        <a-input v-model="form.ownerName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="业主电话" prop="ownerPhone">
        <a-input v-model="form.ownerPhone" placeholder="请输入" :maxLength="11" />
      </a-form-model-item>
      <!-- <template v-if="form.id">
        <a-form-model-item label="项目经理" prop="proBane">
          <a-input v-model="form.proBane" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
        <a-form-model-item label="项目经理电话" prop="proPhone">
          <a-input v-model="form.proPhone" placeholder="请输入" :maxLength="11" />
        </a-form-model-item>
      </template> -->
      <a-form-model-item label="小区名称" prop="minAreaName">
        <a-input v-model="form.minAreaName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="预约时间" prop="reservationTimes">
        <a-cascader
          :options="dtoContent"
          placeholder="请选择预约时间"
          @change="onChangeTime"
          v-model="form.reservationTimes"
        />
        <!-- <a-range-picker @change="onChange" v-model="form.reservationTimes" format="YYYY-MM-DD HH:mm" /> -->
        <!-- <a-range-picker
          @change="onChange"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm"
          v-model="form.reservationTimes"
        /> -->
        <!-- <a-date-picker
          v-model="startValue"
          :disabled-date="disabledStartDate"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="开始时间"
          @openChange="handleStartOpenChange"
        />
        <a-date-picker
          v-model="endValue"
          :disabled-date="disabledEndDate"
          show-time
          format="HH:mm"
          placeholder="End"
          :open="endOpen"
          @openChange="handleEndOpenChange"
        /> -->
        <!-- <a-range-picker
          v-model="form.reservationTime"
          format="YYYY-MM-DD HH:mm"
          show-time
          @change="handleTimeChange"
          style="width: 100%"
        /> -->
        <!-- <a-cascader :options="options" change-on-select @change="onChange" /> -->
        <!-- <p v-if="formattedTime">选择的时间段：{{ formattedTime }}</p> -->
        <!-- <a-input v-model="form.reservationTime" placeholder="请输入" v-show="show" /> -->
        <!-- <a-date-picker show-time placeholder="请选择" v-model="form.reservationTime" @change="onChange" /> -->
      </a-form-model-item>
      <a-form-model-item label="订单类型" prop="orderType" v-if="!form.id">
        <a-radio-group v-model="form.orderType" button-style="solid" @change="handleYu">
          <a-radio-button :value="0"> 普通服务单 </a-radio-button>
          <a-radio-button :value="1"> 预约服务单 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <template v-if="form.orderType">
        <a-form-model-item label="预约姓名" prop="reservationName">
          <a-input v-model="form.reservationName" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
        <a-form-model-item label="预约电话" prop="reservationPhone">
          <a-input v-model="form.reservationPhone" placeholder="请输入" :maxLength="11" />
        </a-form-model-item>
      </template>
      <!-- <template v-if="form.id">
        <a-form-model-item label="VR地址状态" prop="vrState">
          <a-radio-group v-model="form.vrState" button-style="solid">
            <a-radio-button :value="0"> 未配置 </a-radio-button>
            <a-radio-button :value="1"> 已配置 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="VR地址" prop="vrUrl">
          <a-input v-model="form.vrUrl" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
      </template> -->
      <a-form-model-item label="企业品牌" prop="tenantFirmId" v-if="userType !== 1">
        <a-select
          show-search
          :allowClear="true"
          v-model="form.tenantFirmId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleTenant"
        >
          <a-select-option v-for="d in brandList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="经销商" prop="tenantAgentId" v-if="userType !== 2 || isJing">
        <a-select
          show-search
          :allowClear="true"
          v-model="form.tenantAgentId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleAgent"
        >
          <a-select-option v-for="d in agentList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="分销商" prop="tenantId" v-if="userType !== 3">
        <a-select
          show-search
          :allowClear="true"
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in distributionList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item label="分销商" prop="tenantId" v-else>
       <a-select
                  show-search   :allowClear="true"
          v-model="form.tenantId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in agentList" :key="d.userId">{{ d.userName }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item
        label="验收员"
        prop="pressureTestUserId"
        v-if="userType !== 0 && !form.tenantId && userType !== 1"
      >
        <a-select
          show-search
          :allowClear="true"
          v-model="form.pressureTestUserId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleChange"
        >
          <a-select-option v-for="d in inspector" :key="d.userId">{{ d.userName }}-{{ d.userPhone }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="省市区" prop="area">
        <v-distpicker
          :province="form.province"
          :city="form.city"
          :area="form.area"
          @province="onChangeProvince"
          @city="onChangeCity"
          @area="onChangeArea"
          @selected="onRegionSelected"
        >
        </v-distpicker>
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="ownerAddress">
        <!-- <v-distpicker
          :province="form.province"
          :city="form.city"
          :area="form.area"
          @province="onChangeProvince"
          @city="onChangeCity"
          @area="onChangeArea"
          @selected="onRegionSelected"
        >
        </v-distpicker> -->
        <a-input v-model="form.ownerAddress" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <!-- <a-form-model-item label="省市区" prop="reservationName">
          <a-input disabled v-model="form.reservationName" placeholder="请输入" :maxLength="50" />
        </a-form-model-item> -->
      <!-- <a-form-model-item label="详细地址" prop="ownerAddress">
        <mapSearch @changeCenter="changeCenter" @getInfo="getInfo"></mapSearch>
      </a-form-model-item> -->
      <!-- <a-form-model-item label="" prop="ownerAddress" style="margin-top: 60px">
        <mapAdd ref="map" v-if="open"></mapAdd>
      </a-form-model-item> -->

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj, tenantUser, addObj1, pageMy, recordPage } from '@/api/pressure/dispatch'
import mapAdd from '@/components/AMap/index'
import mapSearch from '@/components/AMap/search'
import { listTenant, pageTenant } from '@/api/system/tenant'
import moment from 'moment'
import store from '@/store'
import cos from 'highlight.js/lib/languages/cos'
// import { getUser } from '@/api/biz/user'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: { mapAdd, mapSearch },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      show: false,
      inputValue: '',
      inputValues: '',
      defTimelist: [
        {
          label: '09: 00 - 11: 00',
          value: '09:00 - 11:00',
        },
        {
          label: '11: 00 - 13: 00',
          value: '11:00 - 13:00',
        },
        {
          label: '13: 00 - 15: 00',
          value: '13:00 - 15:00',
        },
        {
          label: '15: 00 - 17: 00',
          value: '15:00 - 17:00',
        },
        {
          label: '17: 00 - 19: 00',
          value: '17:00 - 19:00',
        },
        {
          label: '19: 00 - 21: 00',
          value: '19:00 - 21:00',
        },
      ],

      // 表单参数
      form: {
        id: undefined,
        area: undefined,
        lat: 0,
        log: 0,
        minAreaName: undefined,
        ownerAddress: undefined,
        orderType: 0,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        reservationTimes: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
        reservationPhone: undefined,
        reservationName: undefined,
        proBane: undefined,
        proPhone: undefined,
      },
      open: false,
      showLoading: false,
      inspector: [],
      rules: {
        ownerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        reservationPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        proBane: [{ required: true, message: '请输入项目经理', trigger: 'blur' }],
        proPhone: [
          { required: true, message: '请输入项目经理电话', trigger: 'blur' },
          { validator: validatePhone, trigger: ['blur', 'change'] },
        ],
        vrUrl: [{ required: true, message: '请输入VR 地址', trigger: 'blur' }],
        reservationName: [{ required: true, message: '请输入预约姓名', trigger: 'blur' }],
        tenantFirmId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
        reservationTimes: [{ required: true, message: '请选择预约时间', trigger: 'blur' }],
        // tenantAgentId: [{ required: true, message: '请选择代理商', trigger: 'blur' }],
        // tenantId: [{ required: true, message: '请选择分销商', trigger: 'blur' }],
        minAreaName: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        ownerName: [{ required: true, message: '请输入业主姓名', trigger: 'blur' }],
        // pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        ownerAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        reservationTime: [{ required: true, message: '请选择预约时间', trigger: 'blur' }],
        area: [{ required: true, message: '请在地图上选择位置信息', trigger: 'blur' }],
      },
      superTube: '',
      agentList: [],
      brandList: [],
      isJing: false,
      distributionList: [],
      endOpen: null,
      dtoContent: [],
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    this.getUserList(0)
    // this.getUser(0)
    console.log(store, '对对对对对对')
    this.superTube = store.getters.userTentant.type
    console.log(this.superTube, 'this.superTubethis.superTube')
    // if (this.userType === 2) {
    //   const query = {
    //     tenantIdUp: this.tenantId,
    //   }
    //   this.getMy(query, 3)
    // }
    console.log(this.userType, 'this.userType')

    if (this.userType === 2 || this.userType === 0) {
      // 经销商
      this.getMy(
        {
          type: 1,
        },
        1
      )
    } else if (this.userType === 1) {
      // 企业品牌
      this.getMy(
        {
          type: 2,
        },
        2
      )
    }
    // else if (this.userType === 0) {
    //   // 管理员
    // }
    console.log(this.userType, 'userTypeuserType')
    this.initDtoContentType1()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    tenantId() {
      return this.$store.state.user.userTentant.tenantId
    },
  },
  watch: {},
  methods: {
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    changeCenter(e) {
      console.log(e, '点点滴')
      this.$emit('changelng', e)
      this.$nextTick(() => {
        this.$refs.map.changeLng(e)
      })
    },
    handlePressEntere(e) {
      console.log(e.target.value, '的点点滴滴')
      this.$nextTick(() => {
        this.$refs.map.mapAddress(e.target.value)
      })
    },
    initDtoContentType1() {
      const list = []
      const len = 7
      const today = moment()
      for (let i = 0; i < len; i++) {
        var o = {
          id: i + 1,
          children: this.defTimelist,
        }
        if (i === 0) {
          o.value = today.add(0, 'days').format('YYYY-MM-DD')
          o.label = '今天(' + o.value + ')'
          console.log(o, 'o.timelisto.timelist')
          const currentTime = today.format('HH:mm')
          console.log(currentTime, 'currentTime')

          const filteredSlots = o.children.filter((slot) => {
            // 获取时间段的开始时间
            const startTime = slot.value.split(' - ')[0]
            console.log(startTime, 'startTimestartTime')
            return startTime > currentTime
          })
          o.children = filteredSlots
        } else if (i === 1) {
          o.value = today.add(1, 'days').format('YYYY-MM-DD')
          o.label = '明天(' + o.value + ')'
        } else if (i === 2) {
          o.value = today.add(2, 'days').format('YYYY-MM-DD')
          o.label = '后天(' + o.value + ')'
        } else {
          o.label = today.add(i, 'days').format('YYYY-MM-DD')
          o.value = today.add(i, 'days').format('YYYY-MM-DD')
        }
        list.push(o)
      }
      console.log(list, 'listlistlist')

      this.dtoContent = list
    },
    onChangeTime(e) {
      console.log(e, '大名鼎鼎的')
      this.form.reservationTime = e[0] + '  ' + e[1]
      console.log(this.form.reservationTime, ' this.form.reservationTimes')
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    // 企业品牌发生变化
    handleTenant(e) {
      console.log(e, '对对对对对对')
      let obj
      this.brandList.forEach((v) => {
        if (v.id === e) {
          obj = v
        }
      })
      if (obj.directRelationship) {
        this.getMy({ type: 3 }, 3)
        this.isJing = false
      } else {
        this.isJing = true
        this.getMy({ type: 2, tenantIdUp: e }, 2)
      }
      console.log(obj, 'objobj')
      // if (this.userType !== 2) {
      //   this.getMy({ tenantIdUp: e, type: 2 }, 2)
      // } else {
      // }
    },
    // 预约状态发生变化
    handleYu() {
      // if(this.form.isShow==0){
      // }else
    },
    // 经销商发生变化
    handleAgent(e) {
      this.getMy({ tenantIdUp: e, type: 2 }, 3)
    },
    // 查询经销商厂商
    getUser(e) {
      console.log(this.tenantId, 'this.tenantIdthis.tenantId')
      if (this.userType === 0) {
        // // 管理员 查询企业品牌
        this.getMy({ type: 1 }, 1)
      } else if (this.userType === 1) {
        // 企业品牌
        this.getMy({ tenantIdUp: this.tenantId, type: 2 }, 2)
      } else {
        // // 经销商
        // pageMy().then((res) => {
        //   console.log(res.data.records, '测试====')
        //   this.brandList = res.data.records
        // })
        this.tenantId = store.getters.userTentant.tenantId
      }
    },
    getMy(query, e) {
      // 厂商经销商
      pageMy(query).then((res) => {
        console.log(res.data.records, '测试====666')
        if (e === 1) {
          this.brandList = res.data.records
        } else if (e === 2) {
          console.log()
          // 经销商
          this.agentList = res.data.records
        } else {
          // 分销商
          this.distributionList = res.data.records
        }
      })
    },
    // 查询验收和水工
    getUserList(type) {
      console.log(type, '测试数据====企业品牌啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪')
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
        console.log(res.data, 'res.datares.datares.data')
      })
    },
    // 验收员选择发生变化
    handleChange(e) {
      console.log(e, '的点点滴滴')
      this.inspector.forEach((v) => {
        if (v.userId === e) {
          this.form.pressureTestName = v.userName
          this.form.pressureTestUserPhone = v.userPhone
        }
      })
    },
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.reservationTime =
        moment(e[0]).format('YYYY-MM-DD HH:mm') + '/' + moment(e[1]).format('YYYY-MM-DD HH:mm')
      console.log(this.form.reservationTime, 'this.form.reservationTime')
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.form.city = e.value
      } else {
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择区
    onChangeArea(e) {
      this.form.area = e.value
      const address = this.form.province + this.form.city + e.value
      // this.$nextTick(() => {
      //   this.$refs.map.searchNearby(address)
      // })
    },
    onRegionSelected(e) {
      console.log(e, '顶顶顶顶')
      this.$nextTick(() => {
        this.$refs.map.searchNearby(e)
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getInfo(e) {
      this.form.ownerAddress = e.detailedAddress
      this.form.lat = e.lat
      this.form.log = e.lng
      this.form.province = e.addressComponent.province
      this.form.city = e.addressComponent.city ? e.addressComponent.city : e.addressComponent.province
      this.form.area = e.addressComponent.district
      this.$forceUpdate()
      // console.log(e, 'ddddmm打得动');
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        area: undefined,
        lat: 0,
        log: 0,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        orderType: 0,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
        reservationTimes: undefined,
        proBane: undefined,
        proPhone: undefined,
      }
      this.tags = []
      this.tagslist = []
    },
    // 点击提交型号口径
    handleModelAdd() {
      if (this.form.modelCaliberAddParams.length === 0) {
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      } else {
        const index = this.form.modelCaliberAddParams.length - 1
        if (!this.form.modelCaliberAddParams[index].name) return this.$message.error('请输入口径名称')
        if (!this.form.modelCaliberAddParams[index].sort) return this.$message.error('请输入口径排序')
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      }
    },
    handleModelDel(index) {
      this.form.modelCaliberAddParams.splice(index, 1)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      const name = this.$route.name
      console.log(name, 'namenamename')
      if (name === 'DispatchOne') {
        this.formTitle = '添加预约订单'
        this.isShow = true
      } else {
        this.formTitle = '添加订单'
        this.isShow = false
      }

      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        console.log(response, 'responseresponse')
        // console.log(response.data, 'response.data')
        // // this.tagslist = response.data.productCode.split(',')
        // this.tags = response.data.optionalUnit.split(',')
        // response.data.modelCaliberAddParams = response.data.modelCalibers

        if (response.data.reservationTime) {
          response.data.reservationTimes = response.data.reservationTime.split('/')
        }
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
           this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            const query = JSON.parse(JSON.stringify(this.form))
            if (query.isShow === 1) {
              query.reservationName = undefined
              query.reservationPhone = undefined
            }
            if (this.userType === 0) {
              if (!query.tenantFirmId) {
                query.tenantFirmId = this.tenantId
                query.tenantAgentId = this.tenantId
                query.tenantId = this.tenantId
              } else if (!query.tenantAgentId) {
                query.tenantAgentId = 0
                query.tenantId = query.tenantFirmId
              } else if (!query.tenantId) {
                query.tenantId = query.tenantAgentId
              }
              query.pressureTestUserId = 0
            } else if (this.userType === 1) {
              query.tenantFirmId = this.tenantId
              if (!query.tenantAgentId) {
                query.tenantAgentId = 0
                query.tenantId = query.tenantFirmId
              } else if (!query.tenantId) {
                query.tenantId = query.tenantAgentId
              }
            } else if (this.userType === 2) {
              query.tenantAgentId = this.tenantId
              if (!query.tenantId) {
                query.tenantId = query.tenantAgentId
              }
            }
            if (query.orderType === 0) {
              // 普通订单
              addObj(query)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            } else {
              // 预约订单
              addObj1(query)
                .then((response) => {
                  this.$message.success('新增成功', 3)
                  this.open = false
                  this.$emit('ok')
                })
                .finally(() => {
                  this.submitLoading = false
                })
            }
          }
        } else {
            const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
